import React from 'react';
import SvgIcon from './SvgIcon';

const Events = props => {
    return (
        <SvgIcon viewBox="0 0 17 16" {...props}>
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="map-tools" transform="translate(-1146.000000, -188.000000)" fill="#FFFFFF" fillRule="nonzero">
                    <g id="Group" transform="translate(1117.000000, 148.000000)">
                        <g id="EVENTS" transform="translate(10.000000, 40.000000)">
                            <g id="event-shape" transform="translate(19.500000, 0.000000)">
                                <path d="M13.5,5.64100288 C13.5,2.52584868 11.037675,0 8.00086519,0 C4.96405537,0 2.5,2.52584868 2.5,5.64100288 C2.5,6.7947637 2.83742331,7.85799867 3.41882964,8.76325716 L3.406717,8.76325716 L7.99567406,16 L12.5829007,8.76325716 L12.5811704,8.76325716 C13.1608463,7.85799867 13.5,6.79653872 13.5,5.64100288 Z M8.08208955,7.41052632 C6.81222448,7.41052632 5.78358209,6.31762014 5.78358209,4.96842105 C5.78358209,3.61922197 6.81222448,2.52631579 8.08208955,2.52631579 C9.35195462,2.52631579 10.380597,3.61922197 10.380597,4.96842105 C10.380597,6.31762014 9.3502316,7.41052632 8.08208955,7.41052632 Z"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};

Events.displayName = 'EventsIcon';

export default Events;
